import { Button, Layout, Skeleton, Tag, theme, Typography } from "antd";
import React, { useEffect, useRef } from "react";
import {
  getInstitutionUsers,
  initInstitutionSlice,
} from "../Slices/Institution.slice";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../../shared/components/CustomTable";
import routes from "../../../engine/routes";
import { IoAddSharp } from "react-icons/io5";
import {
  renderUserGender,
  renderUserName,
  subRolesCheckbox,
} from "../../../utils/constants";
import { formatPhoneDisplay } from "../../../utils/phoneUtils";
import { UserCanDoActionMemo } from "../../../engine/AuthRoute";

const { Content, Sider, Header, Footer } = Layout;

export function InstitutionUsers({ unitId, expanded, onClose }) {
  const { id } = useParams();

  const { institution, loading, users } = useSelector(
    state => state.institution,
  );

  const { init, clear } = initInstitutionSlice({ id });

  const dispatch = useDispatch();

  const {
    token: { colorBgLyout },
  } = theme.useToken();

  useEffect(() => {
    if (id !== "new") {
      dispatch(getInstitutionUsers(id));
    }
    return () => {};
  }, []);

  const { name } = institution;

  const m2Exposant = (
    <span>
      m<sup>2</sup>
    </span>
  );

  const inputs = [
    {
      parentLabel: "",
      children: [],
    },
    // {
    //   parentLabel: 'Information',
    //   children: [
    //     {
    //       required: true,
    //       label: 'Prix',
    //       placeholder: 'prix',
    //       addonBefore: 'CHF',
    //       name: 'info.price',
    //       value: '',
    //       type: 'input-currency',
    //       col: 4,
    //     },
    //   ],
    // },
    {
      children: [
        {
          label: "Sauvegarder",
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];
  const formatString = s => {
    return Number(s.replace(/[^0-9.-]+/g, ""));
  };
  const onSubmitForm = data => {
    dispatch(setPropertiesPrestation(data));
  };

  const renderSearchChild = () => {
    return <div>Search</div>;
  };

  const columns = [
    {
      title: "Nom & Prénom",
      width: "20%",
      dataIndex: "user",
      key: "user",
      render: (text, record) => renderUserName(record),
    },
    {
      title: "E-mail",
      dataIndex: "email",
      width: "30%",
      key: "email",
    },
    {
      title: "Téléphone",
      dataIndex: "info",
      key: "info",
      render: info => formatPhoneDisplay(info?.phone || ""),
    },
    {
      title: "Roles",
      width: "30%",
      dataIndex: "subRoles",
      key: "subRoles",
      render: (subRoles, record) => (
        <div>
          {subRolesCheckbox
            ?.filter(e => subRoles?.includes(e.value))
            .map(e => (
              <Tag style={{ margin: 2 }} color={"grey"}>
                {e.label}
              </Tag>
            ))}
        </div>
      ),
    },
  ];

  return (
    <>
      <div
        style={{
          // marginTop: "30px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography.Title level={3} className={""}>
          {institution.name} / Utilisateurs
        </Typography.Title>
        <UserCanDoActionMemo
          route={routes.institutions(id).detailUsers}
          action={"c"}
        >
          <Link to={routes.institutions(id).newUserInstitution("new").path}>
            <Button
              size={"middle"}
              type={"primary"}
              style={{ justifySelf: "flex-start", display: "flex" }}
              icon={<IoAddSharp style={{ marginTop: "0px" }} size={25} />}
            >
              Nouvel utilisateur
            </Button>
          </Link>
        </UserCanDoActionMemo>
      </div>
      <br />

      {loading ? (
        <Skeleton active />
      ) : (
        <>
          <CustomTable
            columns={columns}
            dataSource={users}
            onRowLink={record =>
              routes.institutions(id).detailUser(record._id).path
            }
          />
          {/*<CustomForm*/}
          {/*  dataSource={inputs}*/}
          {/*  handleSubmit={data => onSubmitForm(data)}*/}
          {/*  labelCol={24}*/}
          {/*  refForm={formRef}*/}
          {/*  wrapperCol={24}*/}
          {/*  onValuesChange={undefined}*/}
          {/*/>*/}
        </>
      )}
    </>
  );
}
